import { createSvgIcon } from '@mui/material/utils';

export const PinOutlinedIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="none">
    <path
      d="M0.254097 6.97418L6.99836 0.229918C7.30492 -0.0766394 7.76475 -0.0766394 8.07131 0.229918L10.5238 2.68238C10.907 3.06557 10.7537 3.52541 10.5238 3.75533L9.9873 4.2918L12.2865 6.59098C13.4361 6.36107 16.5783 5.82459 18.2643 7.51066C18.5709 7.81721 18.5709 8.27705 18.2643 8.58361L13.8959 12.9521L18.7242 17.7803C19.0307 18.0869 19.0307 18.5467 18.7242 18.8533C18.4176 19.1598 17.8812 19.0832 17.6512 18.8533L12.823 14.025L8.45451 18.3934C7.99467 18.7766 7.53484 18.6234 7.38156 18.3934C5.69549 16.7074 6.23197 13.5652 6.46189 12.4156L4.1627 10.1164L3.62623 10.6529C3.31967 10.9594 2.85983 10.9594 2.55328 10.6529L0.100819 8.20041C-0.0524597 7.74058 -0.0524616 7.28074 0.254097 6.97418ZM3.24303 8.89017L3.77951 8.35369C4.08607 8.04713 4.5459 8.04713 4.85246 8.35369L7.99467 11.5725C8.22459 11.8025 8.30123 12.0324 8.22459 12.3389C7.99467 13.182 7.61147 15.2512 8.22459 16.6307L16.6549 8.20041C15.3521 7.5873 13.2061 7.97049 12.3631 8.20041C12.1332 8.27705 11.8266 8.20041 11.5967 7.97049L8.45451 4.82828C7.99467 4.36844 8.22459 3.98525 8.45451 3.75533L8.99098 3.21885L7.53484 1.83934L1.86352 7.51066L3.24303 8.89017Z"
      fill="currentColor"
    />
  </svg>,
  'PinOutlined',
);
